import Mailcheck from 'mailcheck';

/* eslint-disable */
export const mailCheck = ({email, onSuggestion, onEmpty}) => {
  Mailcheck.defaultTopLevelDomains.push(
    'pl', 'uk', 'pt', 'rs', 'ro', 'sk', 'si',
    'ca', 'au', 'sg', 'ie',
    'gov.sg', 'edu.sg', 'org.sg', 'com.sg', 'ac.uk',
    'org.uk', 'gov.uk', 'org.au', 'gov.au', 'edu.au',
  );

  Mailcheck.defaultDomains.push(
    'btinternet.com', 'virginmedia.com',
    'blueyonder.co.uk', 'freeserve.co.uk', 'live.co.uk',
    'ntlworld.com', 'o2.co.uk', 'orange.net', 'sky.com',
    'talktalk.co.uk', 'tiscali.co.uk',
    'virgin.net', 'wanadoo.co.uk', 'bt.com',
    'protonmail.com', 'zoho.com', 'email.com', 'fastmail.fm',
    'sina.com', 'qq.com', 'naver.com', 'hanmail.net', 'nate.com',
    '163.com', '126.com', 'foxmail.com', 'bell.net',

    /* Domains used in Canada */
    'yahoo.ca', 'hotmail.ca', 'bell.net', 'shaw.ca',
    'sympatico.ca', 'rogers.com',
  );

  Mailcheck.run({
    email,
    suggested: onSuggestion,
    empty: onEmpty,
  });
};
